import { Route, Routes, HashRouter as Router } from 'react-router-dom';
import Home from '../pages/Home';
import About from '../pages/About';
import Services from '../pages/Services';
import Contact from '../pages/Contact';
import Register from '../forms/Register';
import Documents from '../forms/Documents';
import Access from '../forms/Access';
import TaxPayer from '../pages/TaxPayer';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/register/:IdTaxPayer" element={<Register />} />
      <Route path="/documents/:reqCodeGUID" element={<Documents />} />
      <Route path="/access" element={<Access />} />
      <Route path="/taxpayer/:id" element={<TaxPayer />} />

      <Route path="*" element={<Home />} />
    </Routes>
  );
}

export default AppRoutes;